import { render, staticRenderFns } from "./wiki_sticky_header.vue?vue&type=template&id=f79d9de2"
import script from "./wiki_sticky_header.vue?vue&type=script&lang=js"
export * from "./wiki_sticky_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports